import { useEffect, useState } from "react";
import { Trash2, Star, Loader2 } from "lucide-react";
import { api, API } from "@/lib/api";
import { toast } from "sonner";

export default function ReviewsPanel() {
  const [reviews, setReviews] = useState(null);

  const load = () => api.get("/admin/reviews").then((r) => setReviews(r.data)).catch(() => { setReviews([]); toast.error("Could not load reviews"); });
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this review permanently?")) return;
    try {
      await api.delete(`/admin/reviews/${id}`);
      toast.success("Review deleted");
      setReviews((prev) => prev.filter((r) => r.id !== id));
    } catch {
      toast.error("Could not delete review");
    }
  };

  if (reviews === null) return <div className="flex justify-center py-12"><Loader2 className="animate-spin" /></div>;

  return (
    <div>
      <h2 className="font-display text-xl font-bold mb-1">Customer reviews ({reviews.length})</h2>
      <p className="text-xs text-muted-foreground mb-4">
        Only keep reviews from real customers — fake or seeded reviews are against consumer law in AU & NZ. Delete anything you didn't earn.
      </p>
      <div className="space-y-2">
        {reviews.map((r) => (
          <div key={r.id} className="bg-white border border-ink/10 rounded-md p-4 flex items-start justify-between gap-4" data-testid={`review-row-${r.id}`}>
            <div className="min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-semibold text-sm">{r.name}</span>
                <span className="flex items-center gap-0.5 text-amber-500">
                  {Array.from({ length: r.rating }).map((_, i) => <Star key={i} size={12} fill="currentColor" />)}
                </span>
                <span className="text-xs text-muted-foreground">· {r.product_name} · {(r.created_at || "").slice(0, 10)}</span>
              </div>
              {r.comment && <p className="text-sm text-muted-foreground mt-1 break-words">{r.comment}</p>}
              {r.photos?.length > 0 && (
                <div className="flex gap-2 mt-2">
                  {r.photos.map((p) => (
                    <a key={p} href={`${API}/files/${p}`} target="_blank" rel="noreferrer">
                      <img src={`${API}/files/${p}`} alt="" className="w-12 h-12 object-cover rounded border border-ink/10" />
                    </a>
                  ))}
                </div>
              )}
            </div>
            <button onClick={() => remove(r.id)} className="text-red-500 hover:text-red-700 shrink-0" data-testid={`delete-review-${r.id}`} title="Delete review">
              <Trash2 size={16} />
            </button>
          </div>
        ))}
        {reviews.length === 0 && <p className="text-muted-foreground text-sm py-8 text-center">No reviews yet.</p>}
      </div>
    </div>
  );
}
